import { SYS_SPACE_FIXED_300 } from '@oneaudi/unified-web-alpha-common';
import { pickA11yProps } from '../../utils/pick-a11y-props.js';
import { pickDataProps } from '../../utils/pick-data-props.js';
import React, { forwardRef } from 'react';
import { StyledContainer, StyledContent, StyledHeadlineContainer, StyledTagContainer, StyledCTAContainer, StyledTextButton, StyledDisclaimer, StyledImageContainer, StyledImage, StyledTextContent, StyledPrice, StyledHeadline, StyledIconButtonWrapper, StyledIconButton, StyledPricesContainer } from './index.styles.js';
import { Tag } from '../tag/index.js';
import {} from '../text-button/index.js';
import { Headline } from '../headline/index.js';
import { IconButton } from '../icon-button/index.js';
const Tags = ({ tags }) => {
    if (!tags?.inCard)
        return;
    return (React.createElement(StyledTagContainer, null, tags.inCard
        .filter((t) => !!t)
        .map((tag, i) => (React.createElement(Tag, { key: i, ...tag })))));
};
const CallToActions = ({ textButtons }) => {
    return (React.createElement(StyledCTAContainer, null, textButtons &&
        textButtons
            .filter((t) => !!t)
            .map((textButton, i) => React.createElement(StyledTextButton, { key: i, ...textButton }))));
};
const Image = ({ image }) => {
    if (!image)
        return;
    const srcSet = image.sources
        ?.map((source) => `${source.src} ${source.width}w`)
        .join(', ');
    return (React.createElement(StyledImageContainer, { aspectRatio: image.aspectRatio },
        React.createElement(StyledImage, { src: image.fallbackSrc, alt: image.alt, srcSet: srcSet, sizes: image.sizes, objectFit: image.objectFit })));
};
export const ProductCard = forwardRef(({ className, margin, headline, subline, tags, textButtons, disclaimer, price1, price2, slot1, slot2, image, iconButton, ...rest }, ref) => {
    const { as = 'div' } = headline;
    const headlines = subline ? (React.createElement(StyledHeadlineContainer, null,
        React.createElement(StyledHeadline, { as: as, variant: "headline" }, headline.text),
        React.createElement(StyledHeadline, { variant: "subline", as: subline.as }, subline.text))) : (React.createElement(Headline, { variant: { order: '4', type: 'headline', weight: 'bold' }, tag: as }, headline.text));
    const prices = price1 && price2 ? (React.createElement(StyledPricesContainer, null,
        React.createElement(StyledPrice, { variant: "1" }, price1),
        React.createElement(StyledPrice, { variant: "2" }, price2))) : price1 ? (React.createElement(StyledPrice, { variant: "1" }, price1)) : price2 ? (React.createElement(StyledPrice, { variant: "2" }, price2)) : null;
    return (React.createElement(StyledContainer, { ref: ref, margin: margin, className: className, ...pickA11yProps(rest), ...pickDataProps(rest) },
        iconButton && tags?.corner ? (React.createElement(StyledIconButtonWrapper, null,
            React.createElement(Tag, { ...tags.corner }),
            React.createElement(IconButton, { ...iconButton }))) : tags?.corner ? (React.createElement(Tag, { ...tags.corner, margin: [
                SYS_SPACE_FIXED_300,
                SYS_SPACE_FIXED_300,
                0,
                SYS_SPACE_FIXED_300
            ] })) : iconButton ? (React.createElement(StyledIconButton, { ...iconButton })) : null,
        image && React.createElement(Image, { image: image }),
        React.createElement(StyledContent, null,
            price1 || price2 ? (React.createElement(StyledTextContent, null,
                headlines,
                prices)) : (headlines),
            tags && React.createElement(Tags, { tags: tags }),
            slot1 && slot1,
            disclaimer && disclaimer.position === 'before-buttons' && (React.createElement(StyledDisclaimer, null, disclaimer.text)),
            textButtons && React.createElement(CallToActions, { textButtons: textButtons }),
            slot2 && slot2,
            disclaimer && disclaimer.position === 'after-buttons' && (React.createElement(StyledDisclaimer, null, disclaimer.text)))));
});
ProductCard.displayName = 'ProductCard';
//# sourceMappingURL=index.js.map